export default ({ request }) => ({
  shipmentInfoListApi(data = {}) {
    return request({
      url: '/factory/shipmentInfo/list',
      method: 'post',
      data,
    })
  },
  shipmentInfoListByDraftApi(data = {}) {
    return request({
      url: '/factory/shipmentInfo/listByDraft',
      method: 'post',
      data,
    })
  },
  shipmentInfoChooseByDraftApi(data = {}) {
    return request({
      url: '/factory/shipmentInfo/choose/listByDraft',
      method: 'post',
      data,
    })
  },
  shipmentInfoListByNewApi(data = {}) {
    return request({
      url: '/factory/shipmentInfo/listByNew',
      method: 'post',
      data,
    })
  },
  shipmentInfoListByCustomsBrokerApi(data = {}) {
    return request({
      url: '/factory/shipmentInfo/listByCustomsBroker',
      method: 'post',
      data,
    })
  },
  shipmentInfoDetailApi(data = {}) {
    return request({
      url: '/factory/shipmentInfo/detail',
      method: 'post',
      data,
    })
  },
  shipmentInfoSaveApi(data = {}) {
    return request({
      url: '/factory/shipmentInfo/save',
      method: 'post',
      data,
    })
  },
  shipmentInfoAddByBatchListApi(data = {}) {
    return request({
      url: '/factory/shipmentInfo/addByBatchList',
      method: 'post',
      data,
    })
  },
  shipmentInfoAddShipmentPlanBatchApi(data = {}) {
    return request({
      url: '/factory/shipmentInfo/addShipmentPlanBatch',
      method: 'post',
      data,
    })
  },
  shipmentInfoBookingBackApi(data = {}) {
    return request({
      url: '/factory/shipmentInfo/bookingBack',
      method: 'post',
      data,
    })
  },
  shipmentInfoBookingBackCheckReasonApi(data = {}) {
    return request({
      url: '/factory/shipmentInfo/bookingBack/check/reason',
      method: 'post',
      data,
    })
  },
  shipmentInfoBackApi(data = {}) {
    return request({
      url: '/factory/shipmentInfo/back',
      method: 'post',
      data,
    })
  },
  shipmentInfoCheckDataApi(data = {}) {
    return request({
      url: '/factory/shipmentInfo/checkData',
      method: 'post',
      data,
    })
  },
  shipmentInfoPacklistCheckDataApi(data = {}) {
    return request({
      url: '/factory/shipmentInfo/packlist/checkData',
      method: 'post',
      data,
    })
  },
  shipmentInfoShipmentCheckDataApi(data = {}) {
    return request({
      url: '/factory/shipmentInfo/shipment/checkData',
      method: 'post',
      data,
    })
  },
  shipmentInfoCheckDeclarationDataApi(data = {}) {
    return request({
      url: '/factory/shipmentInfo/declaration/checkData',
      method: 'post',
      data,
    })
  },
  shipmentInfoWaitProductionLoadCheckDataApi(data = {}) {
    return request({
      url: '/factory/shipmentInfo/waitProductionLoad/checkData',
      method: 'post',
      data,
    })
  },
  shipmentInfoShipmentBatchPackingCheckDataApi(data = {}) {
    return request({
      url: '/factory/shipmentInfo/shipmentBatchPacking/checkData',
      method: 'post',
      data,
    })
  },
  shipmentInfoShipmentBatchDetailsCheckDataApi(data = {}) {
    return request({
      url: '/factory/shipmentInfo/shipmentBatchDetails/checkData',
      method: 'post',
      data,
    })
  },
  shipmentInfoGenerateShipmentApi(data = {}) {
    return request({
      url: '/factory/shipmentInfo/generate/shipment',
      method: 'post',
      data,
    })
  },
  shipmentInfoPendingBackApi(data = {}) {
    return request({
      url: '/factory/shipmentInfo/pendingBack',
      method: 'post',
      data,
    })
  },
  shipmentInfoSettlementCompletedApi(data = {}) {
    return request({
      url: '/factory/shipmentInfo/settlementComplete',
      method: 'post',
      data,
    })
  },
  shipmentDeclarationCompletedApi(data = {}) {
    return request({
      url: '/factory/shipmentInfo/declaration/completed',
      method: 'post',
      data,
    })
  },
  shipmentDraftCompletedApi(data = {}) {
    return request({
      url: '/factory/shipmentInfo/draft/completed',
      method: 'post',
      data,
    })
  },
  shipmentInfoListByBookingApi(data = {}) {
    return request({
      url: '/factory/shipmentInfo/listByBooking',
      method: 'post',
      data,
    })
  },
  shipmentInfoListByProductionLoadApi(data = {}) {
    return request({
      url: '/factory/shipmentInfo/listByProductionLoad',
      method: 'post',
      data,
    })
  },
  shipmentInfoListByShipmentApi(data = {}) {
    return request({
      url: '/factory/shipmentInfo/listByShipment',
      method: 'post',
      data,
    })
  },
  shipmentInfoListBySettlementApi(data = {}) {
    return request({
      url: '/factory/shipmentInfo/listBySettlement',
      method: 'post',
      data,
    })
  },
  shipmentInfoBookingCompletedApi(data = {}) {
    return request({
      url: '/factory/shipmentInfo/bookingCompleted',
      method: 'post',
      data,
      timeout: 60000,
    })
  },
  shipmentInfoStuffingCompleteApi(data = {}) {
    return request({
      url: '/factory/shipmentInfo/stuffingComplete',
      method: 'post',
      data,
    })
  },
  shipmentInfoProductionLoadCompletedApi(data = {}) {
    return request({
      url: '/factory/shipmentInfo/productionLoad/completed',
      method: 'post',
      data,
      timeout: 60000,
    })
  },
  shipmentInfoShipmentCompletedApi(data = {}) {
    return request({
      url: '/factory/shipmentInfo/shipment/completed',
      method: 'post',
      data,
    })
  },
  shipmentContainerListApi(data = {}) {
    return request({
      url: '/factory/shipmentContainer/list',
      method: 'post',
      data,
    })
  },
  shipmentContainerChooseListApi(data = {}) {
    return request({
      url: '/factory/shipmentContainer/choose/list',
      method: 'post',
      data,
    })
  },
  shipmentContainerDetailApi(data = {}) {
    return request({
      url: '/factory/shipmentContainer/detail',
      method: 'post',
      data,
    })
  },
  shipmentContainerSaveApi(data = {}) {
    return request({
      url: '/factory/shipmentContainer/save',
      method: 'post',
      data,
    })
  },
  shipmentContainerAddApi(data = {}) {
    return request({
      url: '/factory/shipmentContainer/add',
      method: 'post',
      data,
    })
  },
  shipmentContainerDelApi(data = {}) {
    return request({
      url: '/factory/shipmentContainer/del',
      method: 'post',
      data,
    })
  },
  shipmentContainerCheckDataApi(data = {}) {
    return request({
      url: '/factory/shipmentContainer/checkData',
      method: 'post',
      data,
    })
  },
  shipmentContainerBoxListApi(data = {}) {
    return request({
      url: '/factory/shipmentContainerBox/list',
      method: 'post',
      data,
    })
  },
  shipmentContainerBoxSaveApi(data = {}) {
    return request({
      url: '/factory/shipmentContainerBox/save',
      method: 'post',
      data,
    })
  },
  shipmentContainerBoxDelApi(data = {}) {
    return request({
      url: '/factory/shipmentContainerBox/del',
      method: 'post',
      data,
    })
  },
  shipmentBatchListByChooseApi(data = {}) {
    return request({
      url: '/factory/shipmentBatch/listByChoose',
      method: 'post',
      data,
    })
  },
  shipmentBatchListApi(data = {}) {
    return request({
      url: '/factory/shipmentBatch/list',
      method: 'post',
      data,
    })
  },
  shipmentBatchDelApi(data = {}) {
    return request({
      url: '/factory/shipmentBatch/del',
      method: 'post',
      data,
    })
  },
  shipmentExportCheckDataApi(data = {}) {
    return request({
      url: '/factory/shipmentBatch/checkData',
      method: 'post',
      data,
    })
  },
  shipmentBatchGoodsListApi(data = {}) {
    return request({
      url: '/factory/shipmentBatchGoods/list',
      method: 'post',
      data,
    })
  },
  shipmentBatchBoxListApi(data = {}) {
    return request({
      url: '/factory/shipment/batch/box/list',
      method: 'post',
      data,
    })
  },
  shipmentBatchBoxGoodsListApi(data = {}) {
    return request({
      url: '/factory/shipment/batch/box/goods/list',
      method: 'post',
      data,
    })
  },
  shipmentBatchBoxGoodsDetailApi(data = {}) {
    return request({
      url: '/factory/shipment/batch/box/goods/detail',
      method: 'post',
      data,
    })
  },
  shipmentBatchBoxGoodsExportCheckApi(data = {}) {
    return request({
      url: '/factory/shipment/batch/box/goods/exportCheck',
      method: 'post',
      data,
    })
  },
  shipmentContainerListSumApi(data = {}) {
    return request({
      url: '/factory/shipmentContainer/listSum',
      method: 'post',
      data,
    })
  },
  shipmentDocListApi(data = {}) {
    return request({
      url: '/factory/shipment/doc/list',
      method: 'post',
      data,
    })
  },
  shipmentDocUploadApi(data = {}) {
    return request({
      url: '/factory/shipment/doc/upload',
      method: 'post',
      data,
    })
  },
  shipmentDocDelApi(data = {}) {
    return request({
      url: '/factory/shipment/doc/del',
      method: 'post',
      data,
    })
  },
  shipmentDocDetailApi(data = {}) {
    return request({
      url: '/factory/shipment/doc/detail',
      method: 'post',
      data,
    })
  },
  shipmentDocUpdateApi(data = {}) {
    return request({
      url: '/factory/shipment/doc/update',
      method: 'post',
      data,
    })
  },
  shipmentExecutionLogListApi(data = {}) {
    return request({
      url: '/factory/shipment/execution/log/list',
      method: 'post',
      data,
    })
  },
  shipmentBookingInfoApi(data = {}) {
    return request({
      url: '/factory/shipmentInfo/bookingInfo',
      method: 'post',
      data,
    })
  },
  shipmentContainerBookingListApi(data = {}) {
    return request({
      url: '/factory/shipment/container/booking/list',
      method: 'post',
      data,
    })
  },
  shipmentUpdateBookingInfoApi(data = {}) {
    return request({
      url: '/factory/shipmentInfo/updateBooking',
      method: 'post',
      data,
    })
  },
  shipmentPackingListCheckDataApi(data = {}) {
    return request({
      url: '/factory/shipmentPackingList/checkData',
      method: 'post',
      data,
    })
  },
  shipmentPackingListApi(data = {}) {
    return request({
      url: '/factory/shipmentPackingList/packing/list',
      method: 'post',
      data,
    })
  },
  shipmentChangeDeclarationAmount(data = {}) {
    return request({
      url: '/factory/shipmentPackingList/changeDeclarationAmount',
      method: 'post',
      data,
    })
  },
  shipmetBuildHsData(data = {}) {
    return request({
      url: '/factory/shipmentPackingList/buildHsData',
      method: 'post',
      data,
      timeout: 60000,
    })
  },
  shipmentPackBoxListApi(data = {}) {
    return request({
      url: '/factory/shipmentPackingList/pack/box/list',
      method: 'post',
      data,
    })
  },

  shipmentPackListApi(data = {}) {
    return request({
      url: '/factory/shipmentPackingList/pack/list',
      method: 'post',
      data,
    })
  },
  shipmentBatchListByPlanConfirmApi(data = {}) {
    return request({
      url: '/factory/shipmentBatch/listByPlanConfirm',
      method: 'post',
      data,
    })
  },
  shipmentInfoSaveByPlanConfirmApi(data = {}) {
    return request({
      url: '/factory/shipmentInfo/saveByPlanConfirm',
      method: 'post',
      data,
    })
  },
  shipmentContainerUpdateNoApi(data = {}) {
    return request({
      url: '/factory/shipmentContainer/updateNo',
      method: 'post',
      data,
    })
  },
  shipmentContainerUpdateExtendParameterApi(data = {}) {
    return request({
      url: '/factory/shipmentContainer/update/extendParameter',
      method: 'post',
      data,
    })
  },
  shipmentContainerAddContainerAndBookingApi(data = {}) {
    return request({
      url: '/factory/shipmentContainer/addContainerAndBooking',
      method: 'post',
      data,
    })
  },
  // orderBatchPendingListApi(data = {}) {
  //   return request({
  //     url: '/factory/orderBatch/pending/list',
  //     method: 'post',
  //     data
  //   })
  // },
  shipmentInfoPendingListApi(data = {}) {
    return request({
      url: '/factory/shipmentInfo/pending/list',
      method: 'post',
      data,
    })
  },
  shipmentInfoChooseWaitBookingApi(data = {}) {
    return request({
      url: '/factory/shipmentInfo/choose/wait/booking',
      method: 'post',
      data,
    })
  },
  shipmentInfoCombinedShipmentApi(data = {}) {
    return request({
      url: '/factory/shipmentInfo/combined/shipment',
      method: 'post',
      data,
    })
  },
  shipmentHscodeGoodsSaveAndSyncCustomerGoodsApi(data = {}) {
    return request({
      url: '/factory/shipment/hscode/goods/saveAndSyncCustomerGoods',
      method: 'post',
      data,
    })
  },
  shipmentHscodeGoodsBuilderDataApi(data = {}) {
    return request({
      url: '/factory/shipment/hscode/goods/builderData',
      method: 'post',
      data,
    })
  },
  shipmentHscodeGoodsSpecSaveAndSyncCustomerGoodsApi(data = {}) {
    return request({
      url: '/factory/shipment/hscode/goods/spec/saveAndSyncCustomerGoods',
      method: 'post',
      data,
    })
  },
  shipmentHscodeGoodsSpecListApi(data = {}) {
    return request({
      url: '/factory/shipment/hscode/goods/spec/list',
      method: 'post',
      data,
    })
  },
  shipmentHscodeGoodsSpecDetailApi(data = {}) {
    return request({
      url: '/factory/shipment/hscode/goods/spec/detail',
      method: 'post',
      data,
    })
  },
  // 发运通知书订单汇总表
  shipmentPackingOrderListApi(data = {}) {
    return request({
      url: '/factory/shipment/packing/order/list',
      method: 'post',
      data,
    })
  },
  shipmentPackingOrderUpdateApi(data = {}) {
    return request({
      url: '/factory/shipment/packing/order/update',
      method: 'post',
      data,
    })
  },
  shipmentBatchAllApi(data = {}) {
    return request({
      url: '/factory/shipmentBatch/all',
      method: 'post',
      data,
    })
  },
  shipmentDetailQueryListApi(data = {}) {
    return request({
      url: '/factory/shipment/detail/query/list',
      method: 'post',
      data,
    })
  },
  shipmentDetailQueryFactoryListApi(data = {}) {
    return request({
      url: '/factory/shipment/detail/query/factory/list',
      method: 'post',
      data,
    })
  },
})
